<template>
  <app-modal width="800px" name='invoice-import-error-modal' ref="modal" :title="title" :okText="$t('app.confirm')"
    @before-open="beforeOpen" @before-close="beforeClose">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h6>{{ $t("upload.reasonLabel") }}</h6>
        <span>{{ $t("upload.reason") }}</span>
        <br/>
        <span>{{ $t("upload.useTemplatePrompt") }}</span>
      </div>
      <div class="col-md-12">
        <h6>{{ $t("upload.templateFile") }}</h6>
        <div class="row px-3" style="gap: 24px">
          <div class="bg-random-6 rounded-lg px-4 py-3 col-md-10 d-flex flex-row align-items-center">
            <img height="16px" class="logo" src="images/excel-icon.svg" alt="PVS Logo">
            <span class="ml-2">{{ $t("upload.template") }}</span>
          </div>
          <a class="col-md-1 btn bg-random-6 rounded-lg d-flex justify-content-center align-items-center"
            href="files/Danh_sach_hoa_don.xlsx" download>
            <img height="20px" class="logo" src="images/import-icon.svg" alt="PVS Logo">
          </a>
        </div>
      </div>
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/index';

export default {
  name: 'InvoiceImportErrorModal',
  components: {
    AppModal,
    AppForm,
  },
  data() {
    return {
      title: this.$t('upload.uploadFailed'),
      errorMessage: null,
    };
  },
  methods: {
    beforeOpen(params) {
      this.errorMessage = params.message;
    },
    beforeClose() {
      this.errorMessage = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-import-error-modal.vue